/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type InviteFriendContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileInviteFriendContainer_user$ref: FragmentReference;
export type ProfileInviteFriendContainer_user = {|
  +numUsersRecruited: ?number,
  +$fragmentRefs: InviteFriendContainer_user$ref,
  +$refType: ProfileInviteFriendContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileInviteFriendContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numUsersRecruited",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "InviteFriendContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '50dd149a86421d4ed4cdcb825c32acdb';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileInviteFriendContainer_user.graphql.js